import React from 'react'
import styled from 'styled-components'
import { FilteredPropertyData } from '../../../types/PropertyData'
import { OptionButton } from './OptionButton'
import { useTranslation } from '../../store/hooks/dataHooks'

export type MultipleChoiceProps = {
  propertyDatas: FilteredPropertyData[] | FilteredPropertyData['values']
  value?: string[]
  setValue?: (nextValue: string[]) => void
  className?: string
  singleChoice?: boolean
}

const DetailButton = styled(OptionButton)``

const DetailButtonContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  align-self: stretch;
  vertical-align: top;
`

const DetailButtonImage = styled.div<{ $src?: string }>`
  width: 100px;
  height: 100px;
  background-color: hsla(0, 0%, 68.6%, 0.1);
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('${({ $src }) => $src}');
`

const DetailButtonText = styled.div`
  flex: 1;
  padding: 20px;

  h6 {
    text-align: left;
  }

  p {
    line-height: 1.4;
    margin-top: 0.1em;
    margin-bottom: -0.4em;
  }
`

const ButtonWrap = styled.div`
  margin: 10px;
  display: flex;
  min-width: 350px;
`

const MultipleChoice = styled<React.FC<MultipleChoiceProps>>(
  ({ className, propertyDatas, value, setValue, singleChoice }) => {
    const t = useTranslation()

    return (
      <div className={className}>
        <div>
          {propertyDatas.map(
            ({
              id,
              displayName,
              thumbnail,
              description,
              ...property
            }: FilteredPropertyData | FilteredPropertyData['values'][number]) =>
              (!('disabled' in property) || !property.disabled || property.disabled.type !== 'hidden') && (
                <ButtonWrap key={id}>
                  <DetailButton
                    $active={value?.includes(id)}
                    onClick={() => {
                      if (singleChoice) {
                        setValue?.([id])
                      } else {
                        setValue?.(value?.includes(id) ? value.filter((x) => x !== id) : (value ?? []).concat([id]))
                      }
                    }}
                  >
                    <DetailButtonContent>
                      <DetailButtonImage $src={thumbnail?.url}></DetailButtonImage>
                      <DetailButtonText>
                        <h6>{displayName}</h6>
                        <p>{description}</p>
                      </DetailButtonText>
                    </DetailButtonContent>
                  </DetailButton>
                </ButtonWrap>
              )
          )}
        </div>
        {!singleChoice && propertyDatas.length > 1 && <small>{t('expert.menu.multiselect')}</small>}
      </div>
    )
  }
)`
  margin-top: 10px;

  > div {
    margin: 0 -10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  }

  small {
    display: block;
    margin-top: -5px;
  }
`

export default MultipleChoice
